import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, Modal, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { downloadAndRenameFile, getFileNameFromLink } from "@/utils/allUtils";
import { useLiquidarCarritoMutation, useLiquidarInformesMutation } from "../../redux/api/informeApi";
import { ICarrito } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";
import EnvioProgramado from "./EnvioProgramado";
import dayjs from "dayjs";

type ModalLiquidarCarritoProps = {
  open: boolean;
  onCancel: () => void;
  carrito: ICarrito;
  onCarritoLiquidado: (carrito: ICarrito) => void;
};
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  boxShadow: 24,
  p: 4,
};

const ModalLiquidarCarrito = ({
  carrito,
  open,
  onCancel,
  onCarritoLiquidado,
}: ModalLiquidarCarritoProps) => {
  const darkMode = useAppSelector((state) => state.theme.darkTheme);

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const boxWidth = isMobile ? "100%" : "40rem";

  const [liquidarCarrito] = useLiquidarCarritoMutation();
  const [loading, setLoading] = useState(false);
  const [IvaChecked, setIvaChecked] = useState(false);

  const [selectFecha, setSelectFecha] = useState<Date | any>(dayjs().toDate().toISOString());

  const handleLiquidar = () => {
    console.log("Liquidar carrito", carrito);
    setLoading(true);

    liquidarCarrito({ id: carrito?.idCarrito, flag: IvaChecked, fecha: selectFecha })
      .unwrap()
      .then((r) => {
        MyToastShow({
          message: "Carrito liquidado con éxito",
          type: "success",
        });
        if (r.data) {
          const linkValue = r.data;

          downloadAndRenameFile(linkValue, getFileNameFromLink(linkValue));
        }
        return onCarritoLiquidado({ ...carrito, pdfLiquidacion: r.data });
      })
      .catch((err) => {
        MyToastShow({ message: "Error al liquidar carpeta", type: "error" });
      })
      .finally(() => {
        setLoading(false);
        setIvaChecked(false);
        onCancel();
      });
  }

  const handleCheck = (event: any) => {
    setIvaChecked(event.target.checked);
  };

  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby={`liquidar-carrito-${carrito?.idCarrito}`}
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={(theme) => ({
          ...style,
          width: boxWidth,
          overflow: "auto",
          maxHeight: "100%",
          bgcolor: darkMode ? "#232323" : "#fff",
        })}
        aria-label={`liquidar-container-${carrito?.idCarrito}`}
      >
        <Typography variant="h4"> Liquidar Carpeta</Typography>

        <Typography variant="h6">

          ¿Está seguro que desea liquidar la carpeta {carrito?.idCarrito}?
        </Typography>

        <Checkbox
          checked={IvaChecked}
          onChange={handleCheck}
          inputProps={{ 'aria-label': 'Checkbox' }}
        />
        Liquidar con IVA


        <EnvioProgramado onChange={(value) => setSelectFecha(value)} value={selectFecha} />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <LoadingButton
            loading={loading}
            variant="contained"
            color="error"
            onClick={() => handleLiquidar()}
          >

            Liquidar
          </LoadingButton>
          <Button
            variant="contained"
            color="primary"
            sx={{ ml: 1 }}
            onClick={() => onCancel()}
          >

            Cerrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalLiquidarCarrito;
